import React from "react";
import { Card, CardBody } from "reactstrap";

export const MaintenanceMessage = () => {
    return (
        <div className="d-flex align-items-center h-100 justify-content-center w-100">
        <Card color="secondary">
            <CardBody className="p-4">
            <h2 className="display1 m-0 text-white">We are currently down for maintenance.</h2>
            <h5 className="text-white">Thank you for your patience.  We will be back online soon. </h5>
            </CardBody>
        </Card>
        </div>
    );
}